import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { installGlobalFrontendExceptionHandling } from './services/FrontendExceptionReporter'
import { initAnalytics } from './services/analytics'
import './styles/theme.css'

// Issue #265 — expose build identity at runtime so operators can verify
// which revision a deployed page is serving without digging through CodeBuild.
const buildVersion = {
  sha: process.env.VUE_APP_BUILD_SHA || 'dev',
  timestamp: process.env.VUE_APP_BUILD_TIMESTAMP || '',
  version: process.env.VUE_APP_BUILD_VERSION || '0.0.0',
}
window.__BUILD_VERSION__ = buildVersion
// eslint-disable-next-line no-console -- intentional: emit build identity to the browser console on every load so operators can verify deployed revision via devtools without UI navigation
console.info(
  `[build] 86proof-site v${buildVersion.version} (${buildVersion.sha})${buildVersion.timestamp ? ' ' + buildVersion.timestamp : ''}`,
)

const app = createApp(App)

app.use(router)

installGlobalFrontendExceptionHandling({
  app,
  getRoutePath: () => router.currentRoute.value?.fullPath,
})

initAnalytics(router)

app.mount('#app')
